import enhance from 'packages/core/features/searchField'

import SearchField from './SearchField'

export default enhance(SearchField)
